<template>
<div>
  <el-table
    :data="currencyIntroductionList"
  >
    <el-table-column
      prop="coinType"
      label="币种名称">
    </el-table-column>
    <el-table-column
      prop="devideTime"
      label="分红时间">
    </el-table-column>
    <el-table-column
      prop="dividePeople"
      label="分红人数">
    </el-table-column>
    <el-table-column
      prop="divideAmount"
      label="分红总量">
    </el-table-column>
    <el-table-column
      label="操作">
      <template slot-scope="scope">
        <el-button
          type="primary"
          icon="el-icon-edit"
          circle
          size="small"
          @click="handleEdit(scope.row)"
        ></el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          circle
          size="small"
          @click="handleRemove(scope.row.id)"
        ></el-button>
      </template>
    </el-table-column>
  </el-table>
  <pagination
    :size="pagination.size"
    :page="pagination.page"
    :total="totalCount"
    @pageChanged="handlePageChanged"
    >
  </pagination>
  <!-- <currency-introduction-detail @refresh="refreshList" :id="introductionId"></currency-introduction-detail> -->
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Pagination from 'components/pagination';
// import CurrencyIntroductionDetail from '../detail';

export default {
  name: 'CurrencyIntroductionList',
  data() {
    return {
      introductionId: null
    };
  },
  components: {
    Pagination,
    // CurrencyIntroductionDetail
  },
  computed: {
    ...mapState('currencyIntroductionSetting', [
      'currencyIntroductionList',
      'pagination', 
      'totalCount'
    ])
  },
  methods: {
    ...mapMutations('currencyIntroductionSetting', ['toggleDetailDialogVisible']),
    ...mapActions('currencyIntroductionSetting', ['remove']),
    handlePageChanged(pagination) {
      this.$emit('refresh', pagination);
    },
    handleEdit(currency) {
      this.introductionId = currency.id;
      this.toggleDetailDialogVisible(true);
    },
    handleRemove(id) {
      this.$confirm('确认要删除该币种吗？', '提示', { type: 'warning' }).then(
        () => {
          this.remove(id).then(() => {
            this.$message.success('删除成功！');
            this.$emit('refresh');
          });
        }
      );
    },
    refreshList() {
      this.$emit('refresh');
    }
  }
}
</script>

<style lang="less" scoped>

</style>
